var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7196 8.37361L16.8925 7.3337L13.8411 0.869652C13.2944 -0.282549 11.7103 -0.297196 11.1589 0.869652L8.10748 7.3337L1.28039 8.37361C0.0560969 8.55913 -0.434557 10.1361 0.453292 11.0393L5.39254 16.068L4.22431 23.1716C4.01403 24.4556 5.30842 25.4174 6.39253 24.8169L12.5 21.4628L18.6075 24.8169C19.6916 25.4125 20.986 24.4556 20.7757 23.1716L19.6075 16.068L24.5467 11.0393C25.4346 10.1361 24.9439 8.55913 23.7196 8.37361Z",
    fill: "#2C2E4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarActive);
export default __webpack_public_path__ + "static/media/star-active.6e5b06ce90c4b47639f38f9e7bb622ff.svg";
export { ForwardRef as ReactComponent };